import { IListItemFormatter } from '@/models/common/list-item-formatter';
import { IListItem } from '@/models/common/list-item';

const SortByTextComparer: IListItemComparer = (l, r) => l.text.localeCompare(r.text)

export const listOptionsFilter = (items: any[], formatter: IListItemFormatter, sortFn?: IListItemComparer) => {
    return (items || [])
        .map(p => formatter(p))
        .sort(sortFn || SortByTextComparer);
};

export type IListItemComparer = (left: IListItem, right: IListItem) => number
